import { Component, OnInit, Input } from '@angular/core';
import moment from "moment";


@Component({
    selector: 'app-flight-details',
    templateUrl: './flight-details.component.html',
    styleUrls: ['./flight-details.component.scss'],
    standalone: false
})
export class FlightDetailsComponent implements OnInit {

  @Input() flightDetails: any = {};
  @Input() localeStr;
  @Input() timeFormat;
  departureTime: string = '';
  arrivalTime: string = '';

  constructor() { }

  ngOnInit() {
    this.departureTime = moment(this.flightDetails.departDateNoTimeZone).format(this.timeFormat);
    this.arrivalTime = moment(this.flightDetails.arrivalDateNoTimeZone).format(this.timeFormat);
  }

}
